import { SVG, SVGProps } from './svg'

export function IconLineChartType(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 30 30">
      <path d="m12 11.293 6 6 5.646-5.646.708.707L18 18.707l-6-6-5.646 5.647-.708-.707L12 11.293Z" />
    </SVG>
  )
}
